export function isType(action, actionCreators) {
    if (actionCreators instanceof Array) {
        return actionCreators
            .map(actionCreator => actionCreator.type)
            .some(type => action.type === type);
    }
    else {
        return action.type === actionCreators.type;
    }
}
export function union(_arg) {
    return undefined;
}
//# sourceMappingURL=actiontype.js.map